import React from 'react';
import {Helmet} from 'react-helmet';
import {RouteComponentProps} from 'react-router-dom';
import {useSelector} from 'react-redux';
import b_ from 'b_';

import Header, {headerMeaningfulSelector} from 'client/common/components/header2';
import {HeaderButton} from 'client/common/components/header2/types';
import {Spin} from 'client/common/components/lego';
import Footer from 'client/common/components/footer';
import {createLink} from 'client/common/utils/window';
import {useRumCounter} from 'client/common/utils/rum';

import {getTestBuckets} from 'client/common/store/selectors/user';

import I18N from 'assets/i18n/root';

import {useArticles} from '../../hooks/articles';
import {IListProps} from '../../types';

const i18n = I18N;
const b = b_.with('articles-list');

const headerButtons: HeaderButton[] = ['help', 'create', 'dialog', 'wallet'];

export type ContentTypeArticle = 'article' | 'news' | 'testing';

interface ArticleListProps
    extends RouteComponentProps<{
        tag: ContentTypeArticle;
    }> {}

export default function ArticleList(props: ArticleListProps) {
    const testBuckets = useSelector(getTestBuckets);

    useRumCounter({
        page: 'quicksurvey.articles-list',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets
    });

    const {tag = 'article'} = props.match?.params;

    const {data, status} = useArticles(tag);

    return (
        <>
            <Helmet>
                <title>{i18n.articlesPage.title}</title>
            </Helmet>
            <Header className={b('header')} buttons={headerButtons} />
            <div className={b()}>
                <div className={b('wrapper')}>
                    {status === 'loading' ? (
                        <div className={b('spin_wrapper')}>
                            <Spin className={b('spin')} size='xs' view='default' progress />
                        </div>
                    ) : (
                        <List data={data} tag={tag} />
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

function List({data, tag}: IListProps) {
    const pageTitle: {[key in ContentTypeArticle]?: string} = {
        news: i18n.articlesPage.news.mainHeader
    };

    return (
        <>
            {data?.length ? (
                <>
                    <h1 className={b('title')}>{pageTitle[tag] ?? i18n.articlesPage.mainHeader}</h1>
                    {data.map(article => (
                        <div key={article.slug} className={b('short-info')}>
                            <a className={b('link')} href={createLink(`/articles/${article.slug}`)}>
                                {article.approvedTitle}
                            </a>
                            <div
                                dangerouslySetInnerHTML={{__html: article.approvedPreview.html}}
                                className={b('text-preview')}
                            />
                        </div>
                    ))}
                </>
            ) : (
                <div className={b('no-articles')}>
                    <p> {i18n.articlesPage.noArticlesMessage}</p>
                </div>
            )}
        </>
    );
}
